export const UPGRADE_REQUIRED_EVENT = 'sweetspot:upgrade-required';

export type UpgradeWallKind = 'items' | 'domain' | 'footer' | 'edits' | 'ordering' | 'generic';

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly body?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function upgradeWallKindForMessage(message: string): UpgradeWallKind {
  const value = message.toLowerCase();
  if (value.includes('item') || value.includes('product')) return 'items';
  if (value.includes('domain')) return 'domain';
  if (value.includes('footer') || value.includes('powered by')) return 'footer';
  if (value.includes('edit') || value.includes('theme') || value.includes('spot')) return 'edits';
  if (value.includes('order')) return 'ordering';
  return 'generic';
}

export function dispatchUpgradeRequired(message: string, kind?: UpgradeWallKind): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(UPGRADE_REQUIRED_EVENT, {
    detail: { message, kind: kind ?? upgradeWallKindForMessage(message) },
  }));
}

export function isUpgradeRequired(error: unknown): error is ApiError {
  return error instanceof ApiError && error.status === 402;
}
